import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CategoryViewModel} from '../../model/view/CategoryViewModel';
import {ProductViewModel} from '../../model/view/ProductViewModel';
import {SearchBoxResponseModel} from '../../model/view/SearchBoxResponseModel';

@Component({
  selector: 'v-mini-search-result',
  templateUrl: './mini-search-box-result.component.html',
  styleUrls: []
})
export class MiniSearchBoxResultComponent implements OnInit {
  constructor() {
  }

  @Output()
  public onClickOnProduct = new EventEmitter();

  @Output()
  public onClickOnCategory = new EventEmitter();

  @Input()
  public urlToAllResult: string = null;

  @Input()
  public products: ProductViewModel[] = [];

  @Input()
  public categories: CategoryViewModel[] = [];

  @Input()
  public showSearchResult = false;

  @Input()
  set searchResult(_searchResult: SearchBoxResponseModel) {
    this.products = _searchResult.products;
    this.categories = _searchResult.categories;

    this.showSearchResult = !!this.products.length || !!this.categories.length;
  }

  public redirectToAllResult() {
    window.location.href = this.urlToAllResult;
  }

  public forward(_url: string) {
    if (!_url) {
      return;
    }

    window.location.href = _url;
  }

  ngOnInit() {
  }

}
